import { useMuseModule } from '../../muse/src/config/index'
import { useMuseRoutes } from '../../muse/src/router/index'
import type { Component } from 'vue'
import type { RouteRecordRaw } from 'vue-router'
import type { NavItem } from './config/nav'

export interface ModuleConfig {
  key: string
  label: string
  /** 默认落地页：介绍页（登录后与站点根路径都进这里） */
  homePath: string
  pathPrefixes: string[]
  adminPaths?: string[]
  /** 账号弹窗（左下角用户）显示哪些分节；缺省仅账号安全 */
  accountSections?: string[]
  /** 公开落地页组件，未配置时站点根路径对游客回退到 /login */
  landing?: Component
  /** 公开落地页的 document.title（模块内自行取词，随语言切换） */
  landingTitle?: () => string
  getMenu: () => NavItem[]
}

export const useModules = (): ModuleConfig[] => {
  const modules: ModuleConfig[] = []
  modules.push(useMuseModule())
  return modules
}

/** 当前展示的模块：记住侧边栏选择；开发环境多模块并存时默认第一个 */
export const useActiveModule = (): ModuleConfig | undefined => {
  const modules = useModules()
  const stored = localStorage.getItem('sidebar_active_type')
  return modules.find((m) => m.key === stored) ?? modules[0]
}

export const useModuleRoutes = (): RouteRecordRaw[] => {
  const routes: RouteRecordRaw[] = []
  routes.push(...useMuseRoutes())
  return routes
}
